import CoverOrOriginalRow from './CoverOrOriginalRow'

export default CoverOrOriginalRow
